/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * AUTO-GENERATED API METHODS - DO NOT EDIT
 * Generated from: CustomerProfileContract
 */

import { apiClient } from '../../utils/api-client';
import type {
  GetUserMerchantsResponseType,
  MessageResponse,
} from '@zlinkx/shared-v2';

export const customerprofileApi = {
  getUserMerchants: async (
  ): Promise<GetUserMerchantsResponseType> => {
    return apiClient.get<GetUserMerchantsResponseType['data']>('/profile/merchants') as Promise<GetUserMerchantsResponseType>;
  },
};